import React, { Component, Fragment } from 'react';
import { PropTypes } from 'prop-types';
import handleFormLanguageTab from '../../../utils/handleFormLanguageTab';

// import moment from 'moment';

import searchSlugsByCollection from '../../../api/graphql/queries/searchSlugsByCollection';

import FormInput from '../../Form/FormInput';
import FormTextarea from '../../Form/FormTextarea';
import ModifyArray from '../../Form/ModifyArray';
import EventLanguageTabsContainer from './EventLanguageTabsContainer';
import DeleteModal from '../../Modal/DeleteModal';
import DateAndTimePicker from '../../Form/DateAndTimePicker';
// import EventArtistsSet from './EventArtistsSet';
// import ListSelection from '../../Form/ListSelection';
import AutocompleteArray from '../../Form/AutocompleteArray';
import AutocompleteArrayPosts from '../../Form/AutocompleteArrayPosts';

import slugify from '../../../utils/slugify';

class EventForm extends Component {
  state = {
    canSubmit: false,
    tabsInfo: null,
    datesInfo: {},
    slugName: '',
    slugError: true,
    checkedItems: [],
    subEventsArray: [],
    // subVenuesArray: [],
    subRelatedPostsArray: [],
    routePosts: [],
    subTicketsArray: [],
    subArtistSetsArray: [],
    eventSlugNames: [],
    // venueSlugNames: [],
    // ticketSlugNames: [],
    // artistSetSlugNames: [],
    beginTime: '',
    endTime: '',
    // venueSets: {},
    totalCapacity: '',
    showDate: false,
    showDateTime: false,
    showTicket: false,
    showVenue: false,
  };

  componentDidMount() {
    const {
      eventSlugNames, formInput, routePosts,
    } = this.props;
    
    console.log("🚀 ~ file: EventForm.jsx ~ line 53 ~ EventForm ~ componentDidMount ~ formInput", formInput)

    if (formInput) {
      console.log('formInput', formInput);
      const { eventSlugNamesWithSubEvents, action } = this.props;

      // initial set up boolean fields: showDate, showDateTime, etc.. if coming from form input query

      this.setState({
        showDate: formInput.showDate || false,
        showDateTime: formInput.showDateTime || false,
        showTicket: formInput.showTicket || false,
        showVenue: formInput.showVenue || false,
      });

      if (formInput.hasOwnProperty('eventsArray') && formInput.eventsArray !== null) {
        // Logic to prevent users from adding as subevents, events that have themselves as parents. Like if Primavera Sound had Primavera Als Barris as subevent and while modifying Primavera Als Barris we were trying to add Primavera Sound as subevent.

        if (eventSlugNamesWithSubEvents && action === 'modify') {
          const arrToBeRemoved = [];
          for (const key in eventSlugNamesWithSubEvents) {
            if (eventSlugNamesWithSubEvents[key] === formInput.eventSlugName) {
              arrToBeRemoved.push(key);
            }
          }
          const eventSlugNamesReduced = [...eventSlugNames];
          arrToBeRemoved.forEach((item) => {
            const currIndex = eventSlugNamesReduced.indexOf(item);
            eventSlugNamesReduced.splice(currIndex, 1);
          });
          const index = eventSlugNamesReduced.indexOf(formInput.eventSlugName);
          eventSlugNamesReduced.splice(index, 1);
          this.setState({
            eventSlugNames: eventSlugNamesReduced,
            subEventsArray: formInput.eventsArray,
          });
        } else {
          const slugNamesReduced = [...eventSlugNames];
          const index = slugNamesReduced.indexOf(formInput.eventSlugName);
          slugNamesReduced.splice(index, 1);
          this.setState({
            subEventsArray: formInput.eventsArray,
            eventSlugNames: slugNamesReduced,
          });
        }
      } else {
        this.setState({ eventSlugNames });
      }
      // the next ifs are to remove the already selected items for the list of suggestions (to prevent they are added twice)
      // if (formInput.hasOwnProperty('venues') && formInput.venues !== null) {
      //   const slugNamesReduced = [...venueSlugNames];
      //   formInput.venues.forEach((item) => {
      //     const index = slugNamesReduced.indexOf(item.toLowerCase());
      //     slugNamesReduced.splice(index, 1);
      //   });
      //   this.setState({
      //     subVenuesArray: formInput.venues,
      //     venueSlugNames: slugNamesReduced,
      //   });
      // }

      if (formInput.hasOwnProperty('tickets') && formInput.tickets !== null) {
        this.setState({
          subTicketsArray: formInput.tickets,
        });
      }

      if (formInput.hasOwnProperty('postSlugNames') && formInput.postSlugNames !== null) {
        const slugNamesReduced = [...routePosts];
        formInput.postSlugNames.forEach((item) => {
          const index = slugNamesReduced.indexOf(item.toLowerCase());
          slugNamesReduced.splice(index, 1);
        });

        this.setState({
          subRelatedPostsArray: formInput.postSlugNames,
          routePosts: slugNamesReduced,
        });
      } else {
        this.setState({ routePosts });
      }

      if (formInput.hasOwnProperty('artistSets') && formInput.artistSets !== null) {
        this.setState({
          subArtistSetsArray: formInput.artistSets,
        });
      }
    } else {
      this.setState({ eventSlugNames });
      // this.setState({ venueSlugNames });
      // this.setState({ ticketSlugNames });
      // this.setState({ artistSetSlugNames });
      this.setState({ routePosts });
    }
  }

  handleDropDown = (checkedItems) => {
    this.setState({ checkedItems });
  };

  getTabsInfo = (state) => {
    this.setState({ tabsInfo: state });
  };

  getDatesInfo = (dates, name) => {
    const { datesInfo } = this.state;
    const currDatesInfo = { ...datesInfo };
    currDatesInfo[name] = dates;
    this.setState({ datesInfo: currDatesInfo });
  };

  submit = (e) => {
    e.preventDefault();

    // const { venueSets } = this.state;
    // const { handleVenueSets } = this.props;
    // handleVenueSets(venueSets);

    const { tabsInfo } = this.state;
    const {
      eventName, slugName, beginTime, endTime, subEventsArray, subArtistSetsArray, subTicketsArray, totalCapacity, subRelatedPostsArray, showDate, showDateTime, showTicket, showVenue,
    } = this.state;
    const { formInput, action, venuesFromArtistSet } = this.props;
    const eventsData = {};
    if (action === 'modify') {
      eventsData.id = (formInput && formInput._id) || '';
    }

    // prepare posturi to the right format
    const postSlugNamesArr = subRelatedPostsArray && subRelatedPostsArray.map(i => i.toLowerCase());
    const postSlugNamesArrFromDB = formInput && formInput.eventSlugName.length && formInput.eventSlugName;

    eventsData.eventSlugName = (slugName && slugName.toLowerCase()) || (formInput && formInput.eventSlugName.toLowerCase());

    eventsData.postSlugNames = postSlugNamesArr || postSlugNamesArrFromDB || [];
    eventsData.eventName = eventName || (formInput && formInput.eventName);
    eventsData.artistSets = (subArtistSetsArray && subArtistSetsArray.map(i => i.toLowerCase())) || [];
    eventsData.eventsArray = (subEventsArray && subEventsArray.map(i => i.toLowerCase())) || [];
    eventsData.tickets = (subTicketsArray && subTicketsArray.map(i => i.toLowerCase())) || [];
    eventsData.venues = (venuesFromArtistSet && venuesFromArtistSet.map(i => i.toLowerCase())) || [];
    eventsData.totalCapacity = parseInt(totalCapacity, 10) || (formInput && parseInt(formInput.totalCapacity, 10)) || 1;
    // eventsData.beginDateTime = `${(datesInfo && datesInfo.beginTime.year) || '00'}-${datesInfo.beginTime.month || '00'}-${(datesInfo && datesInfo.beginTime.day) || '00'}T${(datesInfo && datesInfo.beginTime.hour) || '00'}:${(datesInfo && datesInfo.beginTime.beginTimeminutes) || '00'}:30.000+0000`;
    // eventsData.endDateTime = `${(datesInfo && datesInfo.endTime.year) || '00'}-${(datesInfo && datesInfo.endTime.month) || '00'}-${(datesInfo && datesInfo.endTime.day) || '00'}T${(datesInfo && datesInfo.endTime.hour) || '00'}:${(datesInfo && datesInfo.endTime.endTimeminutes) || '00'}:30.000+0000`;
    // /////////////////////
    eventsData.beginDateTime = beginTime || (formInput && formInput.beginDateTime);
    eventsData.endDateTime = endTime || (formInput && formInput.endDateTime);
    eventsData.eventReadableName = handleFormLanguageTab('eventReadableName', tabsInfo) || {
      en: eventName || '',
    };
    eventsData.image = handleFormLanguageTab('image', tabsInfo);
    eventsData.description = handleFormLanguageTab('description', tabsInfo);

    eventsData.showDate = showDate || false;
    eventsData.showDateTime = showDateTime || false;
    eventsData.showTicket = showTicket || false;
    eventsData.showVenue = showVenue || false;

    const { retrieveOutput, handleClick } = this.props;
    retrieveOutput(eventsData, action);
    handleClick(action);
  };

  enableButton = () => {
    const { eventName } = this.state;
    if (eventName) {
      return this.setState({ canSubmit: true });
    }
    return this.setState({ canSubmit: false });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  updateSlugName = (slugName) => {
    this.setState({ slugName });
  };

  storeText = async (currField, value) => {
    if (currField === 'eventName') {
      const slugName = slugify(value);
      this.updateSlugName(slugName);

      const getEventsSlugQueryResult = await searchSlugsByCollection(slugName, 'events', true);

      if (getEventsSlugQueryResult && getEventsSlugQueryResult.isAuth && getEventsSlugQueryResult.slugNames.length) {
        console.log('item already exists in the DB');
        this.setState({ slugError: true, canSubmit: false });
      } else {
        if (slugName.length) {
          this.setState({ slugError: false, canSubmit: true });
        } else {
          this.setState({ canSubmit: false });
        }
      }
    }
    this.setState({ [currField]: value });
  };

  componentDidUpdate(prevProps, prevState) {
    const { subArtistSetsArray } = this.state;
    const { action } = this.props;

    if ((action === 'create' || action === 'modify') && prevState.subArtistSetsArray !== subArtistSetsArray && subArtistSetsArray.length >= 0) {
      const { handleArtistSetToVenue } = this.props;
      handleArtistSetToVenue(subArtistSetsArray);
    }
  }

  componentWillUnmount() {
    const { clearArtistSetToVenue } = this.props;
    clearArtistSetToVenue();
  }

  storeArray = (name, value) => {
    switch (name) {
      case 'events':
        const { subEventsArray, eventSlugNames } = this.state;
        const addingEventsArray = [...subEventsArray, value];
        const lessEvents = eventSlugNames.filter(i => i !== value.toLowerCase());
        this.setState({ subEventsArray: addingEventsArray, eventSlugNames: lessEvents });
        break;
      // case 'venues':
      //   const { subVenuesArray, venueSlugNames } = this.state;
      //   const addingVenuesArray = [...subVenuesArray, value];
      //   const lessVenues = venueSlugNames.filter(i => i !== value.toLowerCase());
      //   this.setState({ subVenuesArray: addingVenuesArray, venueSlugNames: lessVenues });
      //   break;
      case 'tickets':
        const { subTicketsArray } = this.state;
        const addingTicketsArray = [...new Set([...subTicketsArray, value])];
        this.setState({ subTicketsArray: addingTicketsArray });
        break;
      case 'artistSets':
        const { subArtistSetsArray } = this.state;
        const addingArtistSetArray = [...new Set([...subArtistSetsArray, value])];
        this.setState({ subArtistSetsArray: addingArtistSetArray });
        break;
      case 'posts':
        // const { subRelatedPostsArray } = this.state;
        const addingRoutePostsArray = [...value];
        // const lessPostSlugs = routePosts.filter(i => i !== value.toLowerCase());
        this.setState({ subRelatedPostsArray: addingRoutePostsArray });
        break;

      default:
        break;
    }
  };

  handleUpdatedSubArray = (name, arr, item) => {
    this.setState({
      [name]: arr,
    });
    if (item) {
      switch (name) {
        case 'subEventsArray':
          const { eventSlugNames } = this.state;
          const updatedEventSlugNames = [...eventSlugNames, item.toLowerCase()];
          this.setState({ eventSlugNames: updatedEventSlugNames });
          break;

          // case 'subVenuesArray':
          //   const { venueSlugNames } = this.state;
          //   const updatedVenuesSlugNames = [...venueSlugNames, item.toLowerCase()];
          //   this.setState({ venueSlugNames: updatedVenuesSlugNames });
          //   break;

          // case 'subArtistSetsArray':
          //   const { artistSetSlugNames } = this.state;
          //   const updatedArtistsSlugNames = [...artistSetSlugNames, item.toLowerCase()];
          //   this.setState({ artistSetSlugNames: updatedArtistsSlugNames });
          //   break;

          // case 'subTicketsArray':
          //   const { ticketSlugNames } = this.state;
          //   const updatedTicketSlugNames = [...ticketSlugNames, item.toLowerCase()];
          //   this.setState({ ticketSlugNames: updatedTicketSlugNames });
          //   break;

        case 'subRelatedPostsArray':
          const { routePosts } = this.state;
          const updatedRoutesSlugNames = [...routePosts, item.toLowerCase()];
          this.setState({ routePosts: updatedRoutesSlugNames });
          break;

        default:
          break;
      }
    }
  };

  handleDate = (name, date) => {
    this.setState({
      [name]: date,
    });
  };

  // handleVenueSets = (venueSets) => {
  //   console.log('venueSets', venueSets);
  //   this.setState({ venueSets });
  // };

  render() {
    const {
      subRelatedPostsArray, routePosts, showDate, showDateTime, showTicket, showVenue,
    } = this.state;
    const {
      canSubmit, slugName, slugError, subEventsArray, eventSlugNames, subTicketsArray, subArtistSetsArray,
    } = this.state;
    const {
      handleClick, formInput, action, handleDelete, toggleDeleteInfoScreen, canItemBeDeleted, closeToggleDelete, venuesFromArtistSet,
    } = this.props;
    return (
      <Fragment>
        <div className="bg-black text-white p-4">
          <div className="login">
            <div className="w-full">
              <FormInput name="eventName" title="Event Name" storeText={this.storeText} slugError={slugError} action={action} value={(formInput && formInput.eventName) || ''} slugValidation="slugValidation" />
              <div className="font-americaMonoRegular text-xs mb-4 -mt-2">{`/${slugName || (formInput && formInput.eventSlugName) || ''}`}</div>
            </div>
            {(action === 'display' || action === 'delete')
              && (subRelatedPostsArray.length > 2 || (formInput && formInput.postSlugNames !== null && formInput.postSlugNames.length > 2) ? (
                <FormTextarea name="subPosts" title="Sub Posts" action="display" value={(subRelatedPostsArray.length ? subRelatedPostsArray.join(', ').toUpperCase() : formInput && formInput.hasOwnProperty('postSlugNames') && formInput.postSlugNames !== null && formInput.postSlugNames.join(', ').toUpperCase()) || ''} />
              ) : (
                <FormInput name="subPosts" title="Sub Posts" action="display" value={(subRelatedPostsArray.length ? subRelatedPostsArray.join(', ').toUpperCase() : formInput && formInput.hasOwnProperty('postSlugNames') && formInput.postSlugNames !== null && formInput.postSlugNames.join(', ').toUpperCase()) || ''} />
              ))}
            {(action === 'create' || action === 'modify') && (
              <Fragment>
                <ModifyArray subArray={subRelatedPostsArray} title="Related Posts" name="subRelatedPostsArray" sendUpNewArray={this.handleUpdatedSubArray} />
                <AutocompleteArrayPosts title="Select posts" name="posts" message="The post slug does not exist" suggestions={routePosts} storeArray={this.storeArray} action={action} value={(formInput && formInput.hasOwnProperty('postUri') && formInput.postUri !== null && action === 'create' && formInput.postUri.join(', ')) || ''} />
              </Fragment>
            )}

            {(action === 'display' || action === 'delete')
              && (subEventsArray.length > 2 || (formInput && formInput.eventsArray !== null && formInput.eventsArray.length > 2) ? (
                <FormTextarea name="subEvents" title="Sub Events" action="display" value={(subEventsArray.length ? subEventsArray.join(', ').toUpperCase() : formInput && formInput.hasOwnProperty('eventsArray') && formInput.eventsArray !== null && formInput.eventsArray.join(', ').toUpperCase()) || ''} />
              ) : (
                <FormInput name="subEvents" title="Sub Events" action="display" value={(subEventsArray.length ? subEventsArray.join(', ').toUpperCase() : formInput && formInput.hasOwnProperty('eventsArray') && formInput.eventsArray !== null && formInput.eventsArray.join(', ').toUpperCase()) || ''} />
              ))}
            {(action === 'create' || action === 'modify') && (
              <Fragment>
                <ModifyArray subArray={subEventsArray} title="Sub Events" name="subEventsArray" sendUpNewArray={this.handleUpdatedSubArray} />
                <AutocompleteArray title="Add sub-events" name="events" message="The event slug does not exist" suggestions={eventSlugNames} storeArray={this.storeArray} action={action} value={(formInput && formInput.hasOwnProperty('eventsArray') && formInput.eventsArray !== null && action === 'create' && formInput.eventsArray.join(', ')) || ''} />
              </Fragment>
            )}
            <div className="bg-greyWithinForm mb-4">
              <EventLanguageTabsContainer getTabsInfo={this.getTabsInfo} action={action} sendTabsInfo={formInput && formInput} />
            </div>
            <div className="w-full flex -my-5">
              <DateAndTimePicker title="Begin Time" name="beginTime" handleDate={this.handleDate} existingDate={formInput && formInput.beginDateTime} action={action} />
              <div className="ml-8" />
              <DateAndTimePicker title="End Time" name="endTime" handleDate={this.handleDate} existingDate={formInput && formInput.endDateTime} action={action} />
            </div>
            <div>
              <FormInput storeText={this.storeText} name="totalCapacity" title="Capacity" action={action} value={(formInput && formInput.totalCapacity) || ''} />
            </div>
            {(action === 'display' || action === 'delete')
              && (subArtistSetsArray.length > 2 || (formInput && formInput.artistSets !== null && formInput.artistSets.length > 2) ? (
                <FormTextarea name="subArtistSets" title="Sub ArtistSets" action="display" value={(subArtistSetsArray.length ? subArtistSetsArray.join(', ').toUpperCase() : formInput && formInput.hasOwnProperty('artistSets') && formInput.artistSets !== null && formInput.artistSets.join(', ').toUpperCase()) || ''} />
              ) : (
                <FormInput name="subArtistSets" title="Sub ArtistSets" action="display" value={(subArtistSetsArray.length ? subArtistSetsArray.join(', ').toUpperCase() : formInput && formInput.hasOwnProperty('artistSets') && formInput.artistSets !== null && formInput.artistSets.join(', ').toUpperCase()) || ''} />
              ))}
            {(action === 'create' || action === 'modify') && (
              <Fragment>
                <ModifyArray subArray={subArtistSetsArray} title="ArtistSets" name="subArtistSetsArray" sendUpNewArray={this.handleUpdatedSubArray} />
                <AutocompleteArray title="Add artistSets" name="artistSets" message="The artistSet slug does not exist" storeArray={this.storeArray} action={action} value={(formInput && formInput.hasOwnProperty('artistSets') && formInput.artistSets !== null && action === 'create' && formInput.artistSets.join(', ')) || ''} />
              </Fragment>
            )}
            <div className="w-full">
              <label className="flex flex-col font-americaMonoRegular text-xs uppercase mb-2" htmlFor="eventVenuesFromArtistSet">
                Event Venues Based on Artist Sets
                <span disabled className="mt-2 rounded-full border-1 py-2 px-8 bg-grey outline-none border-black text-black" style={{ minHeight: '2.25rem' }}>
                  {venuesFromArtistSet.join(', ').toUpperCase()}
                </span>
              </label>
              {action === 'create' && <span className="flex flex-col text-red mt-4" />}
            </div>
            {/* {venuesFromArtistSet.length > 8 ? (
              <FormTextarea name="eventVenuesFromArtistSet" title="Event Venues Based on Artist Sets" action="display" value={venuesFromArtistSet.join(', ').toUpperCase()} />
            ) : (
              <FormInput name="eventVenuesFromArtistSet" title="Event Venues Based on Artist Sets" action="display" value={venuesFromArtistSet.join(', ').toUpperCase()} />
            )} */}

            {/* {(action === 'display' || action === 'delete')
              && (subVenuesArray.length > 3 || (formInput && (formInput.venues !== null && formInput.venues.length > 3)) ? (
                <FormTextarea name="eventVenues" title="Event Venues" action="display" value={(subVenuesArray.length ? subVenuesArray.join(', ').toUpperCase() : formInput && formInput.hasOwnProperty('venues') && formInput.venues !== null && formInput.venues.join(', ').toUpperCase()) || ''} />
              ) : (
                <FormInput name="eventVenues" title="Event Venues" action="display" value={(subVenuesArray.length ? subVenuesArray.join(', ').toUpperCase() : formInput && formInput.hasOwnProperty('venues') && formInput.venues !== null && formInput.venues.join(', ').toUpperCase()) || ''} />
              ))}

            {(action === 'create' || action === 'modify') && (
              <Fragment>
                <ModifyArray subArray={subVenuesArray} title="Venues" name="subVenuesArray" sendUpNewArray={this.handleUpdatedSubArray} />
                <AutocompleteArray title="Add venues" name="venues" message="The venue slug does not exist" suggestions={venueSlugNames} storeArray={this.storeArray} action={action} value={(formInput && formInput.hasOwnProperty('venues') && formInput.venues !== null && action === 'create' && formInput.venues.join(', ')) || ''} />
              </Fragment>
            )}

            {action === 'create' && <EventArtistsSet subVenuesArray={subVenuesArray} action={action} artistSetSlugNames={artistSetSlugNames} storeArray={this.storeArray} handleVenueSets={this.handleVenueSets} />}
            {(action === 'delete' || action === 'display')
              && (formInput.artistSets && formInput.artistSets.length > 2 ? (
                <FormTextarea name="eventArtistSets" title="Event Artist Sets" action="display" value={(formInput && formInput.artistSets.join(', ').toUpperCase()) || ''} />
              ) : (
                <FormInput name="eventArtistSets" title="Event Artist Sets" action="display" value={(formInput && formInput.artistSets.join(', ').toUpperCase()) || ''} />
              ))}
            {action === 'modify' && (
              <Fragment>
                <ModifyArray subArray={subArtistSetsArray} title="Artist Sets" name="subArtistSetsArray" sendUpNewArray={this.handleUpdatedSubArray} arrayLength={3} />
                <AutocompleteArray
                  title="Add artist sets"
                  name="artistSetsModify"
                  message="The artist set slug does not exist"
                  suggestions={artistSetSlugNames}
                  storeArray={this.storeArray}
                  action={action}
                  value={(formInput && formInput.hasOwnProperty('artistSets') && formInput.artistSets !== null && action === 'create' && formInput.artistSets.join(', ')) || ''}
                />
              </Fragment>
            )} */}

            {(action === 'display' || action === 'delete')
              && (subTicketsArray.length > 2 || (formInput && (formInput.tickets !== null && formInput.tickets.length > 2)) ? (
                <FormTextarea name="subTickets" title="Event Tickets" action="display" value={(subTicketsArray.length ? subTicketsArray.join(', ').toUpperCase() : formInput && formInput.hasOwnProperty('tickets') && formInput.tickets !== null && formInput.tickets.join(', ').toUpperCase()) || ''} />
              ) : (
                <FormInput name="subTickets" title="Event Tickets" action="display" value={(subTicketsArray.length ? subTicketsArray.join(', ').toUpperCase() : formInput && formInput.hasOwnProperty('tickets') && formInput.tickets !== null && formInput.tickets.join(', ').toUpperCase()) || ''} />
              ))}

            {(action === 'create' || action === 'modify') && (
              <Fragment>
                <ModifyArray subArray={subTicketsArray} title="Tickets" name="subTicketsArray" sendUpNewArray={this.handleUpdatedSubArray} arrayLength={3} />
                <AutocompleteArray title="Add tickets" name="tickets" message="The ticket slug does not exist" storeArray={this.storeArray} action={action} value={(formInput && formInput.hasOwnProperty('tickets') && formInput.tickets !== null && action === 'create' && formInput.tickets.join(', ')) || ''} />
              </Fragment>
            )}

            <div className="flex w-full justify-around mb-6">
              <label className="flex flex-col font-americaMonoRegular text-xs w-1/8 justify-center uppercase text-white pt-0 items-center">
                Show Date
                <div className="mt-2 pb-0 mr-1">
                  <label className="switch mb-0 pb-0 h-6">
                    <input className="switch" checked={showDate} onChange={() => this.setState({ showDate: !showDate })} type="checkbox" disabled={action === 'display' || action === 'delete'} />
                    <div className="switch-slider btn-yn1 switch-round" />
                  </label>
                </div>
              </label>
              <label className="flex flex-col font-americaMonoRegular text-xs w-1/8 justify-center uppercase text-white pt-0 items-center">
                Show DateTime
                <div className="mt-2 pb-0 mr-1">
                  <label className="switch mb-0 pb-0 h-6">
                    <input className="switch" checked={showDateTime} onChange={() => this.setState({ showDateTime: !showDateTime })} type="checkbox" disabled={action === 'display' || action === 'delete'} />
                    <div className="switch-slider btn-yn1 switch-round" />
                  </label>
                </div>
              </label>
              <label className="flex flex-col font-americaMonoRegular text-xs w-1/8 justify-center uppercase text-white pt-0 items-center">
                Show Ticket
                <div className="mt-2 pb-0 mr-1">
                  <label className="switch mb-0 pb-0 h-6">
                    <input className="switch" checked={showTicket} onChange={() => this.setState({ showTicket: !showTicket })} type="checkbox" disabled={action === 'display' || action === 'delete'} />
                    <div className="switch-slider btn-yn1 switch-round" />
                  </label>
                </div>
              </label>
              <label className="flex flex-col font-americaMonoRegular text-xs w-1/8 justify-center uppercase text-white pt-0 items-center">
                Show Venue
                <div className="mt-2 pb-0 mr-1">
                  <label className="switch mb-0 pb-0 h-6">
                    <input className="switch" checked={showVenue} onChange={() => this.setState({ showVenue: !showVenue })} type="checkbox" disabled={action === 'display' || action === 'delete'} />
                    <div className="switch-slider btn-yn1 switch-round" />
                  </label>
                </div>
              </label>
            </div>
            <div className="flex justify-end my-2">
              <button type="button" className="font-americaMonoBold text-xs px-6 py-2 rounded-full border-white border-1 bg-black text-white uppercase ml-7 mt-2 w-110px" onClick={() => handleClick(action)}>
                Cancel
              </button>
              {action !== 'display' && action !== 'delete' && (
                <button onClick={this.submit} className={` font-americaMonoBold text-xs px-6 py-2 rounded-full  uppercase ml-7 mt-2 w-110px text-black rounded-full py-2 px-4 bg-${canSubmit || action === 'modify' ? 'white' : 'grey'} ${action === 'delete' && 'bg-red text-white'}`} type="submit" disabled={action === 'modify' ? canSubmit : !canSubmit}>
                  {`${(action === 'create' && 'Submit') || (action === 'modify' && 'Change') || (action === 'delete' && 'Delete')}`}
                </button>
              )}
              {action === 'delete' && (
                <button
                  type="button"
                  className="bg-red text-white font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase ml-7 mt-2 w-110px text-black rounded-full py-2 px-4"
                  onClick={() => {
                    handleDelete(formInput._id, formInput.eventSlugName);
                  }}
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
        {toggleDeleteInfoScreen ? (
          canItemBeDeleted ? (
            <DeleteModal zIndex="20" title="Item to be deleted" handleClick={() => handleClick('delete')} closeToggleDelete={closeToggleDelete}>
              {`${formInput.eventName} has been deleted`}
            </DeleteModal>
          ) : (
            <DeleteModal zIndex="20" title="Item cannot be deleted" handleClick={() => handleClick('delete')} closeToggleDelete={closeToggleDelete}>
              {`${formInput.eventName} has other records linked to it and it cannot be deleted.`}
            </DeleteModal>
          )
        ) : null}
      </Fragment>
    );
  }
}

EventForm.propTypes = {
  handleClick: PropTypes.func.isRequired,
  retrieveOutput: PropTypes.func,
  allItems: PropTypes.arrayOf(PropTypes.shape()),
  formInput: PropTypes.shape({}),
  action: PropTypes.string,
  handleDelete: PropTypes.func,
  handleArtistSetToVenue: PropTypes.func,
  toggleDeleteInfoScreen: PropTypes.bool,
  canItemBeDeleted: PropTypes.bool,
  venuesFromArtistSet: PropTypes.arrayOf(PropTypes.string),
  // artistSetSlugNames: PropTypes.arrayOf(PropTypes.string),
  // ticketSlugNames: PropTypes.arrayOf(PropTypes.string),
  eventSlugNames: PropTypes.arrayOf(PropTypes.string),
  routePosts: PropTypes.arrayOf(PropTypes.string),
  eventSlugNamesWithSubEvents: PropTypes.shape(),
  closeToggleDelete: PropTypes.func,
};

EventForm.defaultProps = {
  allItems: [],
  formInput: null,
  action: '',
  retrieveOutput: null,
  handleDelete: null,
  toggleDeleteInfoScreen: false,
  canItemBeDeleted: false,
  venuesFromArtistSet: [],
  // artistSetSlugNames: [],
  // ticketSlugNames: [],
  routePosts: [],
  eventSlugNames: [],
  eventSlugNamesWithSubEvents: {},
  handleArtistSetToVenue: null,
  closeToggleDelete: null,
};

export default EventForm;
